export const MIN_DATE_FOR_RECONCILIATION = new Date("2021-01-01");
